import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"Notary Affidavit — คำสาบานและคำให้การพร้อมรับรองใช้ต่างประเทศ","metaTitle":"Notary Affidavit ไทย รับรองคำสาบานสำหรับใช้ต่างประเทศ | NYC Notary","metaDesc":"รับรอง Affidavit / Statutory Declaration โดย Notarial Services Attorney สภาทนายความ ทั้งไทย-อังกฤษ พร้อม MFA + Ap — ทีมงานตอบไวทุกวัน ปรึกษาก่อนตัดสินใจได้ฟรี"},"en":{"h1":"Notary Affidavit Thailand — Sworn Statements Ready for Global Use","metaTitle":"Notary Affidavit Thailand — Sworn Declaration + MFA + Apostille | NYC","metaDesc":"Affidavits and Statutory Declarations certified by Thai Bar-licensed Notarial Services Attorneys in Thai a — Send your documents for a free eligibility check."}} as const;

export const Route = createFileRoute("/en/notary/affidavit")({
  head: () => {
    const url = `${SEO_SITE}/en/notary/affidavit`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/notary/affidavit", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/notary/affidavit", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/notary/affidavit", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/notary/affidavit", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/notary/affidavit", "/en/notary/affidavit")],
    };
  },
  component: () => <SubServicePage slug="notary/affidavit" locale="en" />,
});
